export const FILE_PICKER_OPEN_EVENT = 'membernest:file-picker-open';
export const FILE_PICKER_CLOSE_EVENT = 'membernest:file-picker-close';

export function notifyFilePickerOpen() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(FILE_PICKER_OPEN_EVENT));
}

export function notifyFilePickerClose() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(FILE_PICKER_CLOSE_EVENT));
}
